import { fetchTrains } from './fetchTrains';

export const FETCH_CONFIG_BEGIN   = 'FETCH_CONFIG_BEGIN'
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS'
export const FETCH_CONFIG_ERROR = 'FETCH_CONFIG_ERROR'

export const fetchConfiguration = () => async dispatch => {
  dispatch({ type: FETCH_CONFIG_BEGIN })
  let config = JSON.parse(localStorage.getItem('ylg_trains_modal_config'))
  if (config) {
    dispatch({ type: FETCH_CONFIG_SUCCESS, payload: config })
    dispatch(fetchTrains())
  }
}
